import React from "react";
import { ImageCardProps } from "@companion-core/shared/app/Components/Cards/ImageCard/ImageCard.model";
import { getCloudinaryOptimizedUrl } from "@companion-core/shared/app/Utils/cloudinary";
import { getSanitizedDescriptionAlt } from "@companion-core/shared/app/Utils/componentHelper";
import "Assets/Styles/scss/imageCard.scss";
import { FontIcon } from "../../FontIcon";

export const ImageCard = ({
  testID,
  className,
  imageUrl,
  imageAlt,
  allInOne = false,
  bottomContent = false,
  withGradient = false,
  iconOverlay,
  children,
}: ImageCardProps) => {
  const optimizedImageUrl = imageUrl
    ? getCloudinaryOptimizedUrl(imageUrl, {
        contentType: "card",
        width: window.innerWidth,
      })
    : undefined;

  return (
    <div
      data-testid={testID}
      className={`image-card${allInOne ? " image-card--centered-content" : ""}${
        bottomContent ? " image-card--bottom-content" : ""
      }`}>
      <div
        data-testid={`${testID}--img`}
        className={`image-card__img ${withGradient ? "image-card__img--gradient" : ""}`}>
        <img
          className="image-card__img-media"
          src={optimizedImageUrl}
          alt={getSanitizedDescriptionAlt(imageAlt) ?? ""}
        />
        {iconOverlay && (
          <div className="image-card__icon-overlay">
            <FontIcon name={iconOverlay} size={42} />
          </div>
        )}
      </div>
      <div data-testid={`${testID}--children`} className={`image-card__content ${className}`}>
        {children}
      </div>
    </div>
  );
};
